<template>
  <div>
    <section>
      <div class="titulo-c3">
        <h6 class="title">
          c) Indicadores Financieros (Elaborado por los Servicios)
        </h6>
      </div>

      <Table :tablaOne="tablaOne" :readOnly="readOnly" />
      <Row :tablaOne="tablaOne" />
      <GraficaDos :tablaOne="tablaOne" />
    </section>

    <section>
      <div class="titulo-c3">
        <h6 class="title">
          d) Cumplimiento Líneas Programáticas o Aspectos Relevantes de la Ley
          de Presupuestos (Elaborado por los Servicios)
        </h6>
      </div>

      <TableCuadroSix
        :addItemListSix="addItemListSix"
        :itemList="itemListOne"
        :removeItem="removeItemSix"
      />
    </section>

    <section>
      <div class="titulo-c3">
        <h6 class="title">
          d) Cumplimiento Líneas Programáticas o Aspectos Relevantes de la Ley
          de Presupuestos (Elaborado por los Servicios)
        </h6>
      </div>

      <TableCuadroEight
        :addItemListEight="addItemListEight"
        :itemList="itemListTwo"
        :removeItem="removeItemEight"
      />
    </section>
    <div v-if="permiso" class="div-button">
      <button v-if="userPermissions" class="buttons" @click="guardarBorrador">
        Guardar Borrador
      </button>
      <button v-if="userPermission" class="buttons" @click="guardarYFinalizar">
        Guardar y Finalizar
      </button>
    </div>
    <div v-else></div>
  </div>
</template>

<script>
import Table from "./IndicadoresFinancieros/Table.vue";
import axios from "axios";
import TableCuadroSix from "./TableCuadro6/TableCuadro6.vue";
import TableCuadroEight from "./TableCuadro8/TableCuadro8.vue";
import Row from "./IndicadoresFinancieros/Row";
import GraficaDos from "./IndicadoresFinancieros/GraficaDos.vue";
import Swal from "sweetalert2";
import { showAlert } from "../../../../components/tools/utils";
import { mapState } from "vuex";

export default {
  props: ["permiso"],
  components: { Table, TableCuadroSix, TableCuadroEight, Row, GraficaDos },
  data() {
    return {
      dates: "",
      tablaOne: {
        indicadorRelacion:
          "Relación Presupuesto Final respecto al Presupuesto Inicial",
        formulaRelacion: "(Presupuesto Final / Presupuesto Inicial) * 100",

        anioTwoRelacion: "0",
        anioOneRelacion: "0",
        AnioActualRelacion: "0",
        NotasRelacion: "",

        anioOnePorcentaje: "0",
        anioTwoPorcentaje: "0",
        anioActualPorcentaje: "0",
        notasPorcentaje: "",
        indicadorPorentaje:
          "Porcentaje de ejecución respecto del Presupuesto Final",
        formulaPorcentaje: "(Gastos devengados / Presupuesto Final) * 100",
      },
      itemListOne: [],
      itemListTwo: [],
      readOnly: true,
      userPermission: true,
      userPermissions: true,
      datosUser: null,
    };
  },

  computed: {
    ...mapState("sesion", ["usuario"]),
  },
  methods: {
    builData: function(type) {
      return {
        nombre: "recursos_financieros",
        elaboracion: type,
        data: {
          content: this.tablaOne,
          cumplimuento: this.itemListOne,
          comportamiento: this.itemListTwo,
        },
        anio: process.env.VUE_APP_ANIO,
        idServicio: this.$route.params.idServicio,
      };
    },
    guardarBorrador: async function() {
      const toSend = this.builData("borrador");
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/`,
          toSend,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        showAlert({
          icon: "success",
          text: "Guardado como Borrador Exitoso",
          timerProgressBar: true,
          timer: 3000,
        });
        console.log(res);
      } catch (error) {
        if (error.response.status === 422) {
          const toSend = {
            nombre: "recursos_financieros",
            elaboracion: "borrador",
            data: {
              content: this.tablaOne,
              cumplimuento: this.itemListOne,
              comportamiento: this.itemListTwo,
            },
            anio: process.env.VUE_APP_ANIO,
            idServicio: this.$route.params.idServicio,
          };

          await axios.put(
            `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/`,
            toSend,
            {
              headers: {
                Authorization: `JWT ${localStorage.getItem("userToken")}`,
              },
            }
          );
          this.obtener();
          showAlert({
            icon: "success",
            text: "Guardado como Borrador Exitoso",
            timerProgressBar: true,
            timer: 3000,
          });
        } else {
          console.log(error);
          showAlert({
            icon: "error",
            text: error.response.data[Object.keys(error.response.data)[0]],
            timerProgressBar: true,
            timer: 3000,
          });
        }
        console.log(error);
      }
    },

    obtener: async function() {
      try {
        const obj = {
          anio: process.env.VUE_APP_ANIO,
          nombre: "recursos_financieros",
        };
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/?anio=${obj.anio}&nombre=recursos_financieros`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        if (res.data.info.content) {
          this.tablaOne = res.data.info.content;
        }

        if (res.data.info.cumplimuento) {
          this.itemListOne = res.data.info.cumplimuento;
        }

        if (res.data.info.comportamiento) {
          this.itemListTwo = res.data.info.comportamiento;
        }
        console.log("datos tabla C", res.data.info.cumplimuento);
      } catch (error) {
        console.log(error);
      }
    },

    addItemListSix: function() {
      const toAddObj = {
        descripcion: "",
        leyInicial: "",
        pptoFinal: "",
        devengado: "",
        observaciones: "",
      };
      this.itemListOne.push(toAddObj);
    },
    removeItemSix: function(index) {
      const pos = this.itemListOne.indexOf(index);
      this.itemListOne.splice(pos, 1);
    },

    addItemListEight: function() {
      const toAddObj = {
        iniciativasInversion: "",

        pptoFinalAnio: "",
        ejecucionAnio: "",
        notas: "",
      };
      this.itemListTwo.push(toAddObj);
    },
    removeItemEight: function(index) {
      const pos = this.itemListTwo.indexOf(index);
      this.itemListTwo.splice(pos, 1);
    },

    guardarYFinalizar: async function() {
      const toSend = this.builData("finalizado");

      Swal.fire({
        title: "Guardar y Finalizar",
        text: "¿Desea guardar los datos?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Confirmar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const res = await axios.post(
              `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/`,
              toSend,
              {
                headers: {
                  Authorization: `JWT ${localStorage.getItem("userToken")}`,
                },
              }
            );
            showAlert({
              icon: "success",
              text: "Guardado y finalizado exitosamente.",
              timerProgressBar: true,
              timer: 3000,
            });
            console.log(res);
          } catch (error) {
            if (error.response.status === 422) {
              const toSend = {
                nombre: "recursos_financieros",
                elaboracion: "finalizado",
                data: {
                  content: this.tablaOne,
                  cumplimuento: this.itemListOne,
                  comportamiento: this.itemListTwo,
                },
                anio: process.env.VUE_APP_ANIO,
                idServicio: this.$route.params.idServicio,
              };

              await axios.put(
                `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/`,
                toSend,
                {
                  headers: {
                    Authorization: `JWT ${localStorage.getItem("userToken")}`,
                  },
                }
              );

              showAlert({
                icon: "success",
                text: "Documento Guardado ",
                timerProgressBar: true,
                timer: 3000,
              });
            } else {
              console.log(error);
              showAlert({
                icon: "error",
                text: error.response.data[Object.keys(error.response.data)[0]],
                timerProgressBar: true,
                timer: 3000,
              });
            }
            console.log(error);
          }
          this.$router.push({
            name: "buttons",
            params: { idUsuario: this.usuario.id },
          });
        }
      });
    },

    obtenerRevision: async function() {
      try {
        const toSend = process.env.VUE_APP_ANIO;
        console.log("To send", toSend);
        const res = await axios.post(
          `${process.env.VUE_APP_RUTA_API}/instituciones/revisiones/${this.$route.params.idServicio}/ultima_revision/`,
          {
            anio: toSend,
          },
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );

        this.datosUser = res.data;

        console.log("Hola mundo", this.datosUser);

        const relacionUs = this.usuario.servicios.find(
          (s) => s.id === this.$route.params.idServicio
        );
        if (!relacionUs) return;
        console.log("revisando user", relacionUs);
        // Guardar Borrador Encargado BGI
        if (
          this.datosUser.siguienteAccion === "jefe_servicio" ||
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 4)
        ) {
          this.userPermissions = false;
        }

        //Guardar y finalizar Encargado BGI
        if (
          this.datosUser.siguienteAccion === "jefe_servicio" ||
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 4)
        ) {
          this.userPermission = false;
        }

        //Guardar y finalizar Jefe de Servicio
        if (
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 3)
        ) {
          this.userPermission = false;
        } else if (
          this.datosUser.a === undefined ||
          (this.datosUser.siguienteAccion === "jefe_servicio" &&
            relacionUs.rolId === 3)
        ) {
          this.userPermission = true;
        }
        if (
          this.datosUser.siguienteAccion === "jefe_servicio" ||
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 5)
        ) {
          //Guardar funcionario
          this.userPermissions = false;
        }

        //Guardar Borrador Jefe de Servicio

        if (
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 3)
        ) {
          this.userPermissions = false;
        } else if (
          this.datosUser.a === undefined ||
          (this.datosUser.siguienteAccion === "jefe_servicio" &&
            relacionUs.rolId === 3)
        ) {
          this.userPermissions = true;
        }
        console.log("Estado buttonssssss", this.userPermissions);
      } catch (error) {
        console.log(error);
      }
    },
    obtenerRelacionUsuarioServicio() {
      const relacionUs = this.usuario.servicios.find(
        (s) => s.id === this.$route.params.idServicio
      );
      if (!relacionUs) return;
      if (relacionUs.permisos.find((p) => p.permisoId === 5)) {
        this.userPermission = false;
      }
    },

    obtenerRelacionUsuarioServicioss() {
      const data = JSON.parse(localStorage.getItem("user"));
      const relacionUs = data.servicios.find(
        (s) => s.id === parseInt(this.$route.params.idServicio)
      );
      if (!relacionUs) return;
      if (
        relacionUs.permisos.find((p) => p.permisoId === 11) ||
        relacionUs.rolId === 3 ||
        relacionUs.rolId === 4 ||
        relacionUs.rolId === 5
      ) {
        this.readOnly = false;
      }
    },
  },

  mounted() {
    this.obtener();
    this.obtenerRelacionUsuarioServicio();
    this.obtenerRevision();
    this.obtenerRelacionUsuarioServicioss();
  },
};
</script>

<style scoped>
.cnt-main {
  margin: 20px 80px;
}
.title-head {
  border-top: 1px solid #ccc;
  border-right: 1px solid #ccc;
  border-left: 1px solid #ccc;
}
.titulo-c3 {
  font-size: 1.1rem;
  color: #2b425f;
  font-weight: bold;
  margin: 0;
}
.head-data {
  background-color: #cfcccc;
  margin: 0;
}
.title {
  padding: 1rem;
  margin: 0;
  font-weight: bold;
}
.titulo-c3 {
  font-size: 1.1rem;
  color: #2b425f;
  font-weight: bold;
  margin: 0;
  text-align: center;
}
.table > tbody,
.table > thead {
  vertical-align: middle;
}
.button-add {
  background: #25a2b7 !important;
  color: white !important;
  border: none;
  width: 25px;
  height: 25px;
  border-radius: 14px;
  padding: 0 !important;
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 0;
}
.table-title {
  background: #efefef;
}
input {
  width: 90%;
  border: 1px solid #ccc;
  background: transparent !important;
}
table {
  font-size: 1rem !important;
  margin: 0;
  border: 1px solid #f5f5f5;
}
thead {
  background-color: #f5f5f5;
  color: #24c6ab;
  text-align: left !important;
}
tr:hover {
  background: none !important;
  text-align: left !important;
}
th {
  font-size: 1rem !important;
  text-align: left !important;
}
.table-resaltar {
  font-weight: bold;
  background: #f5f5f5;
}
.table-resaltar:hover {
  background: #f5f5f5 !important;
}
td {
  text-align: left !important;
}
.table-striped > tbody > tr:nth-child(even) > td,
.table-striped > tbody > tr:nth-child(even) > th {
  background-color: #f5f5f5;
}
.table-striped > thead > tr > th {
  background-color: #f5f5f5;
}

.buttons {
  border: none;
  cursor: pointer;
  width: 20%;
  height: 21%;
  margin-bottom: 20px;
  margin-top: 20px;
  background: #0b5ed7;
  color: #fff;
  border-radius: 20px;
  margin-right: 20px;
}

.div-button {
  display: flex;
  justify-content: center;
}
</style>
